import { authHeader } from '@/_helpers';
export const openaiService = {
    getSentiment,
    getAnswer,
    getPrompts,
    getCallPrompt,
    inspectCallPrompt,
    getFormation,
    runVerifier,
    previewVerifier,
    updateVerifierResult,
    previewMeetingAi,
    updateMeetingAiResult,
};

const apiUrl = process.env.VUE_APP_ROOT_API;


function getSentiment(email_id,explanation) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({email_id,explanation})
    };
    return fetch(`${apiUrl}/openai/get-sentiment`, requestOptions).then(handleResponse);
}

function getFormation(website) {
    const requestOptions = {
      method: 'POST',
      headers: authHeader('application/json'),
      body: JSON.stringify({ website }),
    }
    return fetch(`${apiUrl}/openai/get-formation`, requestOptions).then(
      handleResponse,
    )
  }

function getCallPrompt(params) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify(params)
    };
    const url = params.force_regenerate
        ? `${apiUrl}/openai/callAnswers`
        : `https://api2.oliverlist.com/openai/callAnswers`;
    return fetch(url, requestOptions).then(handleResponse);
}

function inspectCallPrompt(params) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify(params)
    };
    return fetch(`${apiUrl}/openai/callAnswers/inspect`, requestOptions).then(handleResponse);
}

function getAnswer(email_response_id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    const url = `https://api2.oliverlist.com/openai/answers/${email_response_id}`;
    return fetch(url, requestOptions).then(handleResponse);

}

function getPrompts(email_response_id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    const url = `https://api2.oliverlist.com/openai/prompts/${email_response_id}`;
    return fetch(url, requestOptions).then(handleResponse);
}

function runVerifier(notification_id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ notification_id })
    };
    return fetch(`${apiUrl}/openai/run-verifier`, requestOptions).then(handleResponse);
}

function previewVerifier(notification_id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ notification_id })
    };
    return fetch(`${apiUrl}/openai/preview-verifier`, requestOptions).then(handleResponse);
}

function updateVerifierResult(notification_id, task_fake, justification) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ notification_id, task_fake, justification })
    };
    return fetch(`${apiUrl}/openai/update-verifier-result`, requestOptions).then(handleResponse);
}

function previewMeetingAi(notification_id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ notification_id })
    };
    return fetch(`${apiUrl}/openai/preview-meeting-ai`, requestOptions).then(handleResponse);
}

function updateMeetingAiResult(notification_id, meeting_status, response) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ notification_id, meeting_status, response })
    };
    return fetch(`${apiUrl}/openai/update-meeting-ai-result`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
